<template>
  <!--Draft-->
  <div v-if="!readOnly">

    <h3 v-if="!preview" class="text-xl font-medium">Last opp filer:</h3>

    <div class="border-2 rounded mb-4 text-lg w-3/4">
      <div class="bg-bluegray-300 p-4 font-medium text-lg">
        <span>{{ $t('schema.common.action.uploadedEconomyFiles') }}</span>
      </div>
      <div class="w-full p-4">
        <div v-for="file in this.files" class="mb-2 flex" :key="file.id">
          <div class="w-3/4">
            <a :href=file.url class="py-3 underline text-lightblue-300"
              title="$t('schema.common.action.download.description')">
              <font-awesome-icon icon="file" class="mr-2" />
              <span class="mr-4">{{ file.name }}</span>
            </a>
          </div>
          <!--Delete button-->
          <div class="w-1/4 flex justify-end">
            <button class="mr-2 mt-4 flex justify-end" @click="removeFile(file.id)">
              <font-awesome-icon icon="trash" class="mr-2" />
              <span>{{ $t('schema.common.action.remove') }}</span>
            </button>
          </div>

        </div>
        <input type="file" style="display: none" ref="fileInput"
          accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          @change="fileUploadChange" />
        <button v-if="files.length < 10" class="btn btn--charcoalgray text-lg mr-2 flex mt-auto"
          @click="fileUploadClick">
          <font-awesome-icon icon="upload" class="mr-2" />
          <span>{{ $t('schema.common.action.uploadFile') }}</span>
        </button>
        <Loading small="true" v-if="this.isWorking" />
      </div>
    </div>
  </div>

  <!--Public mode-->
  <div v-else-if="this.model.properties?.economyFiles.length > 0" class="mb-6">
    <div class="border-2 rounded mb-4 text-lg w-3/4">
      <div class="bg-bluegray-300 p-4 font-medium text-lg">
        <span>{{ $t('schema.common.action.uploadedEconomyFiles') }}</span>
      </div>
      <div class="w-full p-4">
        <div v-for="file in this.model.properties?.economyFiles" class="mb-2 flex" :key="file.id">
          <div class="w-3/4">
            <a :href=file.url class="py-3 underline text-lightblue-300"
              title="$t('schema.common.action.download.description')">
              <font-awesome-icon icon="file" class="mr-2" />
              <span class="mr-4">{{ file.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      files: this.model.properties?.economyFiles,
      isWorking: false,
    };
  },
  methods: {
    fileUploadClick() {
      this.$refs.fileInput.click();
      this.$refs.fileInput.value = null;
    },
    fileUploadChange(e) {
      const newFileUploaded = e.target.files || e.dataTransfer.files;
      const [newFile] = newFileUploaded;
      this.submitFile(newFile);
      this.isWorking = true;
    },
    submitFile(file) {
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        axios.post(`${window.location.origin}/api/schema/UploadMultipleEconomyFile/${this.model.contentId}/`, formData)
          .then((response) => {
            this.uploadResult = response;
            this.getFiles();
            this.isWorking = false;
          }, (error) => {
            this.uploadResult = false;
            this.statusMessage = error;
            this.isWorking = false;
          });
      }
    },
    removeFile(fileId) {
      this.isWorking = true;
      axios.post(`${window.location.origin}/api/schema/RemoveMultipleEconomyFile/${this.model.contentId}/${fileId}`, null)
        .then((response) => {
          this.removeFileResult = response.data;
          this.getFiles();
          this.isWorking = false;
        }, (error) => {
          this.statusMessage = error;
          this.isWorking = false;
        });
    },
    getFiles() {
      fetch(`${window.location.origin}/api/schema/GetEconomyFiles/${this.model.contentId}`)
        .then((response) => {
          response.json().then((data) => {
            this.files = data;
          });
        });
    },
  },
};
</script>
